(function(){
  const root = document.body;

  const asnaniNormalizePath = (path) => {
    path = path || '/';
    return path.replace(/^\/(en|ar)(?=\/)/, '') || '/';
  };

  const asnaniUrlParams = new URLSearchParams(window.location.search || '');
  const asnaniForced = (asnaniUrlParams.get('as_lang') || asnaniUrlParams.get('lang') || '').split('-')[0].toLowerCase();
  const asnaniHtmlLang = ((document.documentElement.getAttribute('lang') || root.getAttribute('lang') || 'ar').split('-')[0] || 'ar').toLowerCase();
  const asnaniPathLang = window.location.pathname.startsWith('/en/') ? 'en' : (window.location.pathname.startsWith('/ar/') ? 'ar' : '');

  // مصدر واحد وواضح للغة:
  // 1) ?as_lang=en/ar للصفحات الخاصة التي لا تعمل مع /en/pages.
  // 2) /en أو لغة Shopify الرسمية للمنتجات والمجموعات.
  const currentLang = (asnaniForced === 'en' || asnaniForced === 'ar')
    ? asnaniForced
    : (asnaniPathLang || asnaniHtmlLang || 'ar');

  const isEnglish = currentLang === 'en';

  const asnaniApplyBaseLanguage = () => {
    root.classList.toggle('as-lang-en', isEnglish);
    root.classList.toggle('as-lang-ar', !isEnglish);
    root.setAttribute('dir', isEnglish ? 'ltr' : 'rtl');
    root.setAttribute('lang', isEnglish ? 'en' : 'ar');
    document.documentElement.setAttribute('dir', isEnglish ? 'ltr' : 'rtl');
    document.documentElement.setAttribute('lang', isEnglish ? 'en' : 'ar');
  };

  const asnaniApplyLanguageText = () => {
    document.querySelectorAll('[data-lang]').forEach(el => {
      const itemLang = (el.getAttribute('data-lang') || '').split('-')[0].toLowerCase();
      const show = itemLang === (isEnglish ? 'en' : 'ar');
      el.hidden = !show;
      if(show){ el.style.removeProperty('display'); }
      else{ el.style.display = 'none'; }
    });

    document.querySelectorAll('[data-placeholder-ar][data-placeholder-en]').forEach(el => {
      el.setAttribute('placeholder', isEnglish ? el.getAttribute('data-placeholder-en') : el.getAttribute('data-placeholder-ar'));
    });
  };

  const asnaniUpdateLanguageButton = () => {
    document.querySelectorAll('.as-lang-toggle').forEach(btn => {
      btn.textContent = isEnglish ? 'العربية' : 'English';
      btn.setAttribute('aria-label', isEnglish ? 'Change language to Arabic' : 'Change language to English');
    });
    document.querySelectorAll('.as-lang-form input[name="locale_code"]').forEach(input => {
      input.value = isEnglish ? 'ar' : 'en';
    });
  };

  const asnaniIsCustomPagePath = (path) => {
    const p = asnaniNormalizePath(path || window.location.pathname);
    return p === '/' || p === '' || p.startsWith('/pages/');
  };

  const asnaniEnglishHref = (href) => {
    if(!href) return null;
    let url;
    try{ url = new URL(href, window.location.origin); }catch(e){ return null; }
    if(url.origin !== window.location.origin) return null;

    const cleanPath = asnaniNormalizePath(url.pathname);
    url.pathname = cleanPath;

    // صفحاتنا الخاصة: لا نستخدم /en/pages حتى لا يظهر 404.
    if(cleanPath === '/' || cleanPath === '' || cleanPath.startsWith('/pages/')){
      url.searchParams.set('as_lang', 'en');
      return url.pathname + url.search + url.hash;
    }

    // صفحات Shopify الحقيقية: منتجات / مجموعات / سلة / بحث
    // نستخدم /en حتى تتحول بيانات المنتج والوصف من Shopify نفسه.
    if(cleanPath.startsWith('/products/') || cleanPath.startsWith('/collections/') || cleanPath === '/cart' || cleanPath === '/search'){
      url.pathname = '/en' + cleanPath;
      url.searchParams.delete('as_lang');
      url.searchParams.delete('lang');
      return url.pathname + url.search + url.hash;
    }

    return null;
  };

  const asnaniArabicHref = (href) => {
    if(!href) return null;
    let url;
    try{ url = new URL(href, window.location.origin); }catch(e){ return null; }
    if(url.origin !== window.location.origin) return null;

    const cleanPath = asnaniNormalizePath(url.pathname);
    url.pathname = cleanPath;
    url.searchParams.delete('as_lang');
    url.searchParams.delete('lang');
    return url.pathname + url.search + url.hash;
  };

  const asnaniRewriteLinks = () => {
    document.querySelectorAll('a[href]').forEach(a => {
      const original = a.getAttribute('href') || '';
      if(!original || original.startsWith('#') || original.startsWith('mailto:') || original.startsWith('tel:')) return;

      const fixed = isEnglish ? asnaniEnglishHref(original) : asnaniArabicHref(original);
      if(fixed) a.setAttribute('href', fixed);
    });
  };

  // زر اللغة:
  // الصفحات الخاصة /pages والـ FAQ تتحول بدون Shopify حتى لا تظهر 404.
  // صفحات المنتج والمجموعات تستخدم Shopify localization الحقيقي.
  document.addEventListener('submit', function(e){
    const form = e.target.closest('.as-lang-form');
    if(!form) return;

    const input = form.querySelector('input[name="locale_code"]');
    const target = input ? (input.value || '').split('-')[0].toLowerCase() : (isEnglish ? 'ar' : 'en');

    if(asnaniIsCustomPagePath()){
      e.preventDefault();
      const url = new URL(window.location.href);
      url.pathname = asnaniNormalizePath(url.pathname);
      if(target === 'en'){
        url.searchParams.set('as_lang', 'en');
      }else{
        url.searchParams.delete('as_lang');
        url.searchParams.delete('lang');
      }
      window.location.href = url.pathname + url.search + url.hash;
    }
  }, true);

  document.addEventListener('click', function(e){
    const a = e.target.closest('a[href]');
    if(!a) return;
    const href = a.getAttribute('href') || '';
    const fixed = isEnglish ? asnaniEnglishHref(href) : asnaniArabicHref(href);
    if(!fixed || fixed === href) return;
    e.preventDefault();
    window.location.href = fixed;
  }, true);

  const asnaniRunLanguageSystem = () => {
    asnaniApplyBaseLanguage();
    asnaniApplyLanguageText();
    asnaniUpdateLanguageButton();
    asnaniRewriteLinks();
  };

  asnaniRunLanguageSystem();
  document.addEventListener('DOMContentLoaded', asnaniRunLanguageSystem);
  setTimeout(asnaniRunLanguageSystem, 300);
  setTimeout(asnaniRunLanguageSystem, 1200);



  // Currency app compatibility: Hextom and similar currency apps detect standard .money price nodes.
  const asnaniMoneyHTML = (value) => `<span class="money">${value}</span>`;
  const asnaniNotifyCurrencyApps = () => {
    document.dispatchEvent(new Event('asnani:money-updated'));
    document.dispatchEvent(new Event('shopify:section:load'));
    if(window.Hextom && typeof window.Hextom === 'object'){
      try { window.Hextom.event && window.Hextom.event.dispatch && window.Hextom.event.dispatch('money_updated'); } catch(e) {}
    }
  };

  document.addEventListener('click', function(e){
    const menuBtn = e.target.closest('[data-as-menu]');
    if(menuBtn){ document.querySelector('.as-nav')?.classList.toggle('is-open'); }
  });
  const reveals = document.querySelectorAll('.as-reveal');
  if('IntersectionObserver' in window){
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(entry => { if(entry.isIntersecting){ entry.target.classList.add('is-visible'); io.unobserve(entry.target); } });
    }, {threshold:.12});
    reveals.forEach(el => io.observe(el));
  }else{ reveals.forEach(el => el.classList.add('is-visible')); }
  document.addEventListener('click', function(e){
    const thumb = e.target.closest('[data-as-main-media]');
    if(thumb){
      const main = document.getElementById('AsMainProductMedia');
      if(main){ main.src = thumb.getAttribute('data-as-main-media'); }
      document.querySelectorAll('[data-as-main-media]').forEach(btn => btn.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }
  });

  document.querySelectorAll('[data-as-hero-carousel]').forEach(carousel => {
    const slides = Array.from(carousel.querySelectorAll('[data-as-hero-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-as-goto-slide]'));
    if(!slides.length) return;
    let current = slides.findIndex(slide => slide.classList.contains('is-active'));
    if(current < 0) current = 0;
    const delay = parseInt(carousel.getAttribute('data-as-autoplay') || '5000', 10);
    let timer;
    const goTo = (next) => {
      if(!slides.length) return;
      next = (next + slides.length) % slides.length;
      if(next === current) return;
      slides.forEach((slide, index) => {
        slide.classList.remove('is-active','is-prev');
        if(index === current) slide.classList.add('is-prev');
      });
      slides[next].classList.add('is-active');
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === next));
      current = next;
    };
    const restart = () => {
      if(timer) clearInterval(timer);
      timer = setInterval(() => goTo(current + 1), delay);
    };
    carousel.addEventListener('click', e => {
      if(e.target.closest('[data-as-next-slide]')){ goTo(current + 1); restart(); }
      if(e.target.closest('[data-as-prev-slide]')){ goTo(current - 1); restart(); }
      const dot = e.target.closest('[data-as-goto-slide]');
      if(dot){ goTo(parseInt(dot.getAttribute('data-as-goto-slide'), 10)); restart(); }
    });
    carousel.addEventListener('mouseenter', () => { if(timer) clearInterval(timer); });
    carousel.addEventListener('mouseleave', restart);
    restart();
  });


  document.querySelectorAll('[data-as-product-feature-carousel]').forEach(carousel => {
    const slides = Array.from(carousel.querySelectorAll('[data-as-product-feature-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-as-feature-goto-slide]'));
    if(!slides.length) return;
    let current = slides.findIndex(slide => slide.classList.contains('is-active'));
    if(current < 0) current = 0;
    const delay = parseInt(carousel.getAttribute('data-as-autoplay') || '5000', 10);
    let timer;
    const goTo = (next) => {
      next = (next + slides.length) % slides.length;
      if(next === current) return;
      slides.forEach((slide, index) => slide.classList.toggle('is-active', index === next));
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === next));
      current = next;
    };
    const restart = () => {
      if(timer) clearInterval(timer);
      timer = setInterval(() => goTo(current + 1), delay);
    };
    carousel.addEventListener('click', e => {
      if(e.target.closest('[data-as-feature-next-slide]')){ goTo(current + 1); restart(); }
      if(e.target.closest('[data-as-feature-prev-slide]')){ goTo(current - 1); restart(); }
      const dot = e.target.closest('[data-as-feature-goto-slide]');
      if(dot){ goTo(parseInt(dot.getAttribute('data-as-feature-goto-slide'), 10)); restart(); }
    });
    carousel.addEventListener('mouseenter', () => { if(timer) clearInterval(timer); });
    carousel.addEventListener('mouseleave', restart);
    restart();
  });

  // asnanistore reveal fallback: show content even if IntersectionObserver is delayed
  setTimeout(() => { document.querySelectorAll('.as-reveal').forEach(el => el.classList.add('is-visible')); }, 900);

  const canAnimate = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(canAnimate){
    document.querySelectorAll('.tilt').forEach(card => {
      card.addEventListener('mousemove', e => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - .5;
        const y = (e.clientY - r.top) / r.height - .5;
        card.style.transform = `perspective(900px) rotateX(${(-y*7).toFixed(2)}deg) rotateY(${(x*7).toFixed(2)}deg) translateY(-6px)`;
      });
      card.addEventListener('mouseleave', () => { card.style.transform = ''; });
    });
    document.querySelectorAll('.as-product-stage').forEach(stage => {
      const productCard = stage.querySelector('.as-product-card');
      if(stage && productCard){
        stage.addEventListener('mousemove', e => {
          const r = stage.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width - .5;
          const y = (e.clientY - r.top) / r.height - .5;
          productCard.style.transform = `rotateY(${(-9 + x*8).toFixed(2)}deg) rotateX(${(4 - y*6).toFixed(2)}deg)`;
        });
        stage.addEventListener('mouseleave', () => { productCard.style.transform = ''; });
      }
    });
  }

  // Update visible price when Shopify variant changes
  document.addEventListener('change', function(e){
    const select = e.target.closest('.as-variant-select');
    if(!select) return;
    const option = select.options[select.selectedIndex];
    if(!option) return;

    const price = option.getAttribute('data-price') || '';
    const compare = option.getAttribute('data-compare') || '';
    const available = option.getAttribute('data-available') !== 'false';
    const image = option.getAttribute('data-image') || '';

    if(price){
      document.querySelectorAll('[data-as-product-price]').forEach(el => { el.textContent = price; });
    }
    document.querySelectorAll('[data-as-product-compare]').forEach(el => {
      if(compare){
        el.textContent = compare;
        el.classList.remove('is-hidden');
      }else{
        el.textContent = '';
        el.classList.add('is-hidden');
      }
    });

    const form = select.closest('.as-product-form');
    if(form){
      form.querySelectorAll('[data-as-add-to-cart], button[type="submit"]').forEach(btn => {
        btn.disabled = !available;
      });
      if(typeof asnaniSyncProductAvailability === 'function'){ asnaniSyncProductAvailability(form, available); }
    }

    if(image){
      const main = document.getElementById('AsMainProductMedia');
      if(main){ main.src = image; }
    }
  });


  // Mobile-safe add to cart: prevents Shopify error page and shows a clear message inside the product page.
  const asnaniGetLang = () => ((document.documentElement.getAttribute('lang') || document.body.getAttribute('lang') || 'ar').split('-')[0] || 'ar').toLowerCase();

  const asnaniSyncProductAvailability = (form, available) => {
    if(!form) return;
    const addBtn = form.querySelector('[data-as-add-to-cart]');
    const status = document.querySelector('[data-as-product-status]');
    const checkout = document.querySelector('[data-as-dynamic-checkout]');
    const sticky = document.querySelector('[data-as-sticky-order]');

    if(addBtn){
      addBtn.disabled = !available;
      if(!available){
        addBtn.innerHTML = `<span data-lang="ar">غير متوفر حالياً</span><span data-lang="en">Sold out</span>`;
      }else{
        addBtn.innerHTML = `<span data-lang="ar">أضف إلى السلة</span><span data-lang="en">Add to cart</span> 🛒`;
      }
      if(typeof asnaniApplyLanguage === 'function'){ asnaniApplyLanguage(); }
    }

    if(status){ status.classList.toggle('is-hidden', !!available); }
    if(checkout){ checkout.classList.toggle('is-hidden', !available); }

    if(sticky){
      sticky.disabled = !available;
      sticky.innerHTML = available
        ? `<span data-lang="ar">اطلب الآن</span><span data-lang="en">Order now</span>`
        : `<span data-lang="ar">غير متوفر</span><span data-lang="en">Sold out</span>`;
      if(typeof asnaniApplyLanguage === 'function'){ asnaniApplyLanguage(); }
    }
  };

  document.addEventListener('click', function(e){
    const sticky = e.target.closest('[data-as-sticky-order]');
    if(!sticky) return;

    const form = document.querySelector('[data-as-product-form]');
    if(form){
      form.scrollIntoView({behavior:'smooth', block:'center'});
      const addBtn = form.querySelector('[data-as-add-to-cart]');
      setTimeout(() => { if(addBtn && !addBtn.disabled) addBtn.focus(); }, 450);
    }
  });

  document.addEventListener('submit', async function(e){
    const form = e.target.closest('[data-as-product-form]');
    if(!form) return;

    e.preventDefault();

    const addBtn = form.querySelector('[data-as-add-to-cart]');
    const status = document.querySelector('[data-as-product-status]');
    const idInput = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[name="quantity"]');
    const quantity = Math.max(1, parseInt(qtyInput?.value || '1', 10) || 1);

    if(!idInput || !idInput.value){
      if(status){
        status.classList.remove('is-hidden');
        status.classList.remove('is-success');
        status.innerHTML = `<span data-lang="ar">يرجى اختيار المنتج أو النوع أولاً.</span><span data-lang="en">Please choose a product option first.</span>`;
        if(typeof asnaniApplyLanguage === 'function'){ asnaniApplyLanguage(); }
      }
      return;
    }

    if(addBtn && addBtn.disabled){
      if(status){
        status.classList.remove('is-hidden');
        status.classList.remove('is-success');
        status.innerHTML = `<span data-lang="ar">هذا المنتج غير متوفر حالياً. تأكد من كمية المخزون داخل Shopify.</span><span data-lang="en">This product is currently unavailable. Please check inventory in Shopify.</span>`;
        if(typeof asnaniApplyLanguage === 'function'){ asnaniApplyLanguage(); }
      }
      return;
    }

    if(addBtn){
      addBtn.disabled = true;
      addBtn.innerHTML = `<span data-lang="ar">جاري الإضافة...</span><span data-lang="en">Adding...</span>`;
      if(typeof asnaniApplyLanguage === 'function'){ asnaniApplyLanguage(); }
    }

    try{
      const response = await fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id: Number(idInput.value), quantity})
      });

      const data = await response.json().catch(() => ({}));

      if(!response.ok){
        if(status){
          status.classList.remove('is-hidden');
          status.classList.remove('is-success');
          status.innerHTML = `<span data-lang="ar">لا يمكن إضافة المنتج حالياً. غالباً كمية المخزون غير متاحة داخل Shopify.</span><span data-lang="en">This product cannot be added now. Inventory is likely unavailable in Shopify.</span>`;
          if(typeof asnaniApplyLanguage === 'function'){ asnaniApplyLanguage(); }
        }
        if(addBtn){
          addBtn.innerHTML = `<span data-lang="ar">أضف إلى السلة</span><span data-lang="en">Add to cart</span> 🛒`;
          addBtn.disabled = false;
          if(typeof asnaniApplyLanguage === 'function'){ asnaniApplyLanguage(); }
        }
        return;
      }

      if(status){
        status.classList.remove('is-hidden');
        status.classList.add('is-success');
        status.innerHTML = `<span data-lang="ar">تمت إضافة المنتج إلى السلة بنجاح.</span><span data-lang="en">Product added to cart successfully.</span>`;
        if(typeof asnaniApplyLanguage === 'function'){ asnaniApplyLanguage(); }
      }

      asnaniNotifyCurrencyApps();
      const asnaniCartRedirectUrl = (typeof isEnglish !== 'undefined' && isEnglish) ? '/en/cart' : '/cart';
      window.location.href = asnaniCartRedirectUrl;
    }catch(err){
      if(status){
        status.classList.remove('is-hidden');
        status.classList.remove('is-success');
        status.innerHTML = `<span data-lang="ar">حدث خطأ مؤقت. جرّب مرة أخرى أو تحقق من إعدادات المنتج.</span><span data-lang="en">A temporary error occurred. Try again or check product settings.</span>`;
        if(typeof asnaniApplyLanguage === 'function'){ asnaniApplyLanguage(); }
      }
      if(addBtn){
        addBtn.innerHTML = `<span data-lang="ar">أضف إلى السلة</span><span data-lang="en">Add to cart</span> 🛒`;
        addBtn.disabled = false;
        if(typeof asnaniApplyLanguage === 'function'){ asnaniApplyLanguage(); }
      }
    }
  });



  // Prevent accidental horizontal page overflow on mobile.
  const asnaniLockHorizontalOverflow = () => {
    document.documentElement.style.overflowX = 'hidden';
    document.body.style.overflowX = 'hidden';
    const vw = window.innerWidth || document.documentElement.clientWidth;
    document.querySelectorAll('.asnani-page, .shopify-section, .as-section, .as-hero, .as-container, .as-product-page, .as-header, .as-footer').forEach(el => {
      if(el && el.getBoundingClientRect && el.getBoundingClientRect().width > vw + 2){
        el.style.maxWidth = '100%';
        el.style.overflowX = 'hidden';
      }
    });
  };
  asnaniLockHorizontalOverflow();
  window.addEventListener('resize', asnaniLockHorizontalOverflow, {passive:true});
  document.addEventListener('DOMContentLoaded', asnaniLockHorizontalOverflow);



  // Cart quantity buttons
  document.addEventListener('click', function(e){
    const minus = e.target.closest('[data-as-cart-minus]');
    const plus = e.target.closest('[data-as-cart-plus]');
    if(!minus && !plus) return;

    const wrap = e.target.closest('.as-cart-qty');
    const input = wrap ? wrap.querySelector('[data-as-cart-qty]') : null;
    if(!input) return;

    let value = parseInt(input.value || '0', 10);
    if(isNaN(value)) value = 0;

    if(plus) value += 1;
    if(minus) value = Math.max(0, value - 1);

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });



  // Live cart totals: update quantity, item count, and subtotal without pressing "Update cart".
  const asnaniFormatMoney = (cents, currency) => {
    const amount = (Number(cents || 0) / 100);
    const lang = ((document.documentElement.lang || document.body.lang || 'ar').split('-')[0] || 'ar').toLowerCase();
    try{
      return new Intl.NumberFormat(lang === 'en' ? 'en-US' : 'ar-KW', {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'KWD',
        minimumFractionDigits: 3,
        maximumFractionDigits: 3
      }).format(amount);
    }catch(e){
      return amount.toFixed(3);
    }
  };

  const asnaniShowCartStatus = (messageAr, messageEn, isError=false) => {
    const status = document.querySelector('[data-as-cart-live-status]');
    if(!status) return;
    status.classList.remove('is-hidden');
    status.classList.toggle('is-error', !!isError);
    status.innerHTML = `<span data-lang="ar">${messageAr}</span><span data-lang="en">${messageEn}</span>`;
    if(typeof asnaniApplyLanguage === 'function'){ asnaniApplyLanguage(); }
    clearTimeout(status._asTimer);
    status._asTimer = setTimeout(() => status.classList.add('is-hidden'), 2400);
  };

  const asnaniUpdateHeaderCartCount = (count) => {
    const cartIcon = document.querySelector('.as-cart-icon');
    if(!cartIcon) return;
    let badge = cartIcon.querySelector('.as-cart-count');
    if(count > 0){
      if(!badge){
        badge = document.createElement('span');
        badge.className = 'as-cart-count';
        cartIcon.appendChild(badge);
      }
      badge.textContent = count;
    }else if(badge){
      badge.remove();
    }
  };

  const asnaniUpdateCartDOM = (cart, currency) => {
    if(!cart) return;
    const itemCountEl = document.querySelector('[data-as-cart-item-count]');
    const subtotalEl = document.querySelector('[data-as-cart-subtotal]');
    if(itemCountEl) itemCountEl.textContent = cart.item_count || 0;
    if(subtotalEl) subtotalEl.innerHTML = asnaniMoneyHTML(asnaniFormatMoney(cart.total_price, currency));
    asnaniUpdateHeaderCartCount(cart.item_count || 0);

    document.querySelectorAll('[data-as-cart-item]').forEach((itemEl, index) => {
      const item = cart.items[index];
      if(!item){
        itemEl.remove();
        return;
      }
      itemEl.setAttribute('data-as-cart-line', index + 1);
      const qty = itemEl.querySelector('[data-as-cart-qty]');
      if(qty) qty.value = item.quantity;
      const total = asnaniFormatMoney(item.final_line_price || item.line_price, currency);
      itemEl.querySelectorAll('[data-as-cart-line-total], [data-as-cart-mobile-line-total]').forEach(el => {
        el.textContent = total;
      });
      const remove = itemEl.querySelector('.as-cart-remove');
      if(remove){
        remove.setAttribute('href', `/cart/change?line=${index + 1}&quantity=0`);
      }
    });

    asnaniNotifyCurrencyApps();
    if((cart.item_count || 0) === 0){
      window.location.reload();
    }
  };

  let asnaniCartUpdateTimer;
  const asnaniChangeCartLine = async (input) => {
    const form = input.closest('[data-as-cart-form]');
    const itemEl = input.closest('[data-as-cart-item]');
    if(!form || !itemEl) return;
    const line = Number(itemEl.getAttribute('data-as-cart-line'));
    const quantity = Math.max(0, parseInt(input.value || '0', 10) || 0);
    const currency = form.getAttribute('data-as-cart-currency') || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'KWD';

    itemEl.classList.add('is-updating');
    form.classList.add('is-updating');

    try{
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json', 'Accept':'application/json'},
        body: JSON.stringify({ line, quantity })
      });
      const cart = await response.json();
      if(!response.ok){
        throw new Error(cart && (cart.message || cart.description) || 'Cart update failed');
      }
      asnaniUpdateCartDOM(cart, currency);
      asnaniShowCartStatus('تم تحديث السلة تلقائياً.', 'Cart updated automatically.');
    }catch(err){
      asnaniShowCartStatus('حدث خطأ أثناء تحديث السلة. جرّب مرة أخرى.', 'There was an error updating the cart. Please try again.', true);
    }finally{
      itemEl.classList.remove('is-updating');
      form.classList.remove('is-updating');
    }
  };

  document.addEventListener('change', function(e){
    const input = e.target.closest('[data-as-cart-qty]');
    if(!input) return;
    clearTimeout(asnaniCartUpdateTimer);
    asnaniCartUpdateTimer = setTimeout(() => asnaniChangeCartLine(input), 250);
  });



  // Track order page: open pasted carrier tracking link.
  document.addEventListener('submit', function(e){
    const form = e.target.closest('[data-as-track-link-form]');
    if(!form) return;
    e.preventDefault();

    const input = form.querySelector('[data-as-track-link-input]');
    let url = input ? (input.value || '').trim() : '';
    if(!url) return;

    if(!/^https?:\/\//i.test(url)){
      url = 'https://' + url;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
  });


})();
